// @flow
import storage from 'Lib/storage';

import createPersistableReducer from './createPersistableReducer';

export { REHYDRATE, REHYDRATED } from './constants';
export { flush } from './actions';

export const { getRehydrateLifecycle, persistReducer, persistStore, storageCleanup } =
  createPersistableReducer({ storage });
